import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
import translationEN from './en/translation.json';
import translationID from './id/translation.json';
import translationRU from './ru/translation.json';

// Define resources
const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
  ru: {
    translation: translationRU,
  },
};

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // Default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;